/**
 * Whether a country switch keeps the bag's code: only a GwP partner's code, saved by the partner's page with the
 * shopper's entitlement. The entitlement still holds in the new country and web re-checks the code there on the next
 * price check, refusing it where the offer isn't sold. Every other promotion is country-specific and cleared.
 */
export function keepsPartnerCode(
  cartCouponCode: string | undefined,
  savedCouponCode: string | undefined,
  hasPartnerEntitlement: boolean,
) {
  return hasPartnerEntitlement && !!cartCouponCode && cartCouponCode.toLowerCase() === savedCouponCode?.toLowerCase();
}
